import { Organization, Site } from '../../../generated/graphql'
import { create } from 'zustand'

export interface auctionSite {
    auctionName: string
    pipelineCode: string
    locationName: string
    lookoutCodeName: string
    biCode: string
}

export interface PipelinePlusPsiOption {
    id?: string
    productName?: string
    amsPsiType?: string
    description?: string
    amsAutomaticName?: string | null
    durationInDays?: number
    pricePass?: number
    priceFail?: number
}

export interface PsiItem {
    inspection: {
        options: PipelinePlusPsiOption[]
    }
    stock: string
}
export interface PsiInspections {
    items: PsiItem[]
}

export interface IGlobalAuctionStore {
    setCurrentAuctionId: (auctionId: string) => void
    setAuctionSites: (org: Organization) => void
    setPipelinePlusPsiOptions: (inspections: PsiInspections) => void
    auctionId: string
    auctionSites: Array<Site | undefined | null>
    pipelinePlusPsiOptions: Array<PsiItem | undefined | null>
}

const useGlobalAuctionStore = create<IGlobalAuctionStore>((set) => ({
    setCurrentAuctionId: (auctionId: string) => {
        return set({ auctionId })
    },

    setAuctionSites: (org: Organization) => {
        return set({ auctionSites: org?.sites || [] })
    },

    setPipelinePlusPsiOptions: (inspections: PsiInspections) => {
        return set({ pipelinePlusPsiOptions: inspections?.items || [] })
    },

    auctionId: '',
    auctionSites: [],
    pipelinePlusPsiOptions: [],
}))

export default useGlobalAuctionStore
